import { render, staticRenderFns } from "./TestCustomerList.vue?vue&type=template&id=494542ec&scoped=true"
import script from "./TestCustomerList.vue?vue&type=script&lang=js"
export * from "./TestCustomerList.vue?vue&type=script&lang=js"
import style0 from "./TestCustomerList.vue?vue&type=style&index=0&id=494542ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494542ec",
  null
  
)

export default component.exports